/** "1 waiver", "12 waivers", "1,204 waivers": a count a person reads, with its noun, the singular at exactly 1 (Chris,
 *  2026-11-03). A copy of shared-components/plural.ts's line, here because this app compiles only what is under src/;
 *  scripts/tests/test_plural_lint.py holds every copy to the source's line, byte for byte. */
export const plural = (n: number, one: string, many = `${one}s`): string => `${n.toLocaleString('en-US')} ${n === 1 ? one : many}`;
